import * as React from "react";

import { IUser, IEditProps } from "../types";
import Form from "./Form";

export default class Edit extends React.Component<IEditProps> {
  onSubmit = async (values: IUser) => {
    await this.props.update(values);
    this.props.closeRow();
  };

  onDelete = async (values: IUser) => {
    if (window.confirm("Deleting is irreversible, continue?")) {
      await this.props.delete(values);
      this.props.closeRow();
    }
  };

  render() {
    return (
      <Form
        id={this.props.item.id}
        initialValues={this.props.item}
        onSubmit={this.onSubmit}
        onDelete={this.onDelete}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Users/components/Edit.tsx